import { Component, input } from '@angular/core';

@Component({
  selector: 'app-tenant-logo',
  templateUrl: './tenant-logo.component.html',
  styleUrls: ['./tenant-logo.component.scss'],
})
export class TenantLogoComponent {
  tenantId = input.required<string>();
}
